import React from 'react';
import PropTypes from 'prop-types';
import ActionAlert from 'patternity/lib/alert/action_alert';
import _ from 'lodash';
import { withNamespaces } from 'react-i18next';

const countChallenges = (challenges) =>
  Object.values(challenges).reduce(
    (acc, value) => acc + (value.children ? countChallenges(value.children) : 1), 0
  )


class ChallengesUnlocked extends React.Component {
  static propTypes = {
    channel: PropTypes.shape({ name: PropTypes.string }),
    unlockedChallenges: PropTypes.arrayOf(
      PropTypes.shape({
        challenges: PropTypes.object.isRequired,
        experience_id: PropTypes.number.isRequired,
        experience_name: PropTypes.string.isRequired
      })
    ).isRequired,
    fetchUnlockedChallenges : PropTypes.func.isRequired,
  };

  static defaultProps = {
    unlockedChallenges: []
  };

  renderUnlockedMessage({ challenges }) {
    const { t, channel } = this.props;
    const length = countChallenges(challenges)

    if (channel && channel.name) {
      return t(
        `You have just unlocked {{length}} more challenge${ length > 1 ? 's' : ''} in {{channel_name}}. Great work!`,
        {
          length,
          channel_name: channel.name
        }
      );
    }

    return t(
      `You have just unlocked {{length}} more challenge${ length > 1 ? 's' : ''}. Great work!`,
      { length }
    );
  }

  render() {
    if (_.isEmpty(this.props.unlockedChallenges)) return null;

    const { t } = this.props;
    return <div>
      {this.props.unlockedChallenges.map(unlock => {
        const { experience_id } = unlock;

        return <ActionAlert
          key={experience_id}
          title={t('Challenges Unlocked!')}
          showIcon={true}
          showAlert={this.props.showChallengeUnlocked}
          action={{ title: t('Show them now'), onClick: () => this.props.fetchUnlockedChallenges(unlock) }} >
          <p>{this.renderUnlockedMessage(unlock)}</p>
        </ActionAlert>
      })}
    </div>;
  }
}

export default withNamespaces('HubFE')(ChallengesUnlocked)



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenges_unlocked.jsx